// bigIntPolyFill.js
// This is a proper BigInt polyfill function that ensures BigInt is available

const ensureBigIntSupport = () => {
    if (typeof window.BigInt !== 'function') {
      console.warn('BigInt is not supported in this browser. Falling back to workarounds.');
      
      // Add a simple shim that will handle string-based big integers
      // For full functionality, consider using a library like big.js or bignumber.js
      window.BigInt = function(value) {
        // Just return the original value for basic operations
        // This is not a full polyfill but will prevent errors in basic cases
        return String(value);
      };
      
      // Add basic string-based addition for the most common use case
      if (!window.BigInt.prototype) {
        window.BigInt.prototype = {};
      }
    }
  };
  
  export default ensureBigIntSupport;